// eslint-disable-next-line no-barrel-files/no-barrel-files
export { prefersReducedMotion } from './prefers-reduced-motion';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { buildOrderIndex } from './build-order-index';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { isSameOrderIndex } from './is-same-order-index';
export type RectMap = Map<string, DOMRect>;

export const measureRects = (keys: readonly string[], refs: Map<string, HTMLElement>): RectMap => {
	const rects: RectMap = new Map();
	for (const key of keys) {
		const el = refs.get(key);
		if (el) {
			rects.set(key, el.getBoundingClientRect());
		}
	}
	return rects;
};
